import { Grid2 } from "@mui/material";
import React from "react";
import LeftSection from "./sections/LeftSection";
import RightSection from "./sections/RightSection";

export default function ClinicRegistrationPage() {
  return (
    <Grid2 container height={"100vh"} sx={{ bgcolor: "#fafafa" }}>
      {/* Left Section */}
      <LeftSection />
      {/* Right Section */}
      <RightSection />
    </Grid2>
  );
}
